function toggleMobileMenu (){
  const mobileMenuTriggers = document.querySelectorAll('.js_toggle-mobile-menu');
  const bodyEl = document.querySelector('body');
 
  mobileMenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      bodyEl.classList.toggle('state__mobile-menu-open');
    })
  });  
}

export default toggleMobileMenu;